// src/features/commission/api.js
import api from "../../components/axiosComp";

// Global commission
export const updateGlobalCommission = async ({ commissionPercent, notes = "" }) => {
  const { data } = await api.patch("/api/commission/global/update", {
    commissionPercent,
    notes,
  });
  return data; // { message, id }
};

// Per-venue commission
export const updateVenueCommission = async (venueId, { commissionPercent, notes = "" }) => {
  const { data } = await api.patch(`/api/commission/${venueId}`, {
    commissionPercent,
    notes,
  });
  return data; // { message, id }
};

// Effective commission for a venue
export const getEffectiveCommission = async (venueId) => {
  const { data } = await api.get(`/api/commission/${venueId}`);
  return data; // { venueId, commissionPercent }
};
export const getGlobalCommission = async () => {
  const { data } = await api.get("/api/commission/global");
  return data; // { commissionPercent }
};

export const listVenueCommissionOverrides = async () => {
  const { data } = await api.get("/api/commission/venue-overrides");
  return data; // { overrides: { [venueId]: percent } }
};

